"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MdFastForwardIcon = void 0;

var _iconBase = require("../../iconBase");

var MdFastForwardIcon = function MdFastForwardIcon(props) {
  return (0, _iconBase.GenIcon)({
    tag: "svg",
    attr: {
      viewBox: "0 0 24 24"
    },
    child: [{
      tag: "path",
      attr: {
        d: "M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"
      }
    }]
  })(props);
};

exports.MdFastForwardIcon = MdFastForwardIcon;
MdFastForwardIcon.displayName = "MdFastForwardIcon";